import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { MaintenanceService } from './maintenance.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  constructor(private maintenance: MaintenanceService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (this.maintenance.isActive()) {
      return this.router.parseUrl('/maintenance');
    }
    return true;
  }

  canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }
}
